import { Navigate, useParams } from 'react-router-dom';
import { Box, CircularProgress, Alert, Container } from '@mui/material';
import { useProducts, getProductFromPage } from '../context/ProductsContext';
import { RackingSystemDetail } from '../components/products/RackingSystemDetail';
import ProductsSharedSections from '../components/products/ProductsSharedSections';

const ORANGE = '#FF6B00';

export default function RackingSystemPage() {
  const { systemId } = useParams();
  const { pageData, loading, error } = useProducts();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 12 }}>
        <CircularProgress sx={{ color: ORANGE }} />
      </Box>
    );
  }

  if (error || !pageData) {
    return (
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Alert severity="error">{error || 'Unable to load product.'}</Alert>
      </Container>
    );
  }

  const product = getProductFromPage(pageData, systemId);
  if (!product) return <Navigate to="/products" replace />;

  return (
    <Box sx={{ bgcolor: '#fff', overflowX: 'hidden' }}>
      <RackingSystemDetail product={product} />
      <ProductsSharedSections />
    </Box>
  );
}
